import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const userMenu = {
    id: 'user',
    title: 'User',
    type: 'group',
    children: [
        {
            id: 'users',
            title: 'User',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'user-default',
                    title: 'User',
                    type: 'item',
                    url: '/user/default'
                }
            ]
        }
    ]
};

export default userMenu;
